(() => {
    let carousels = document.querySelectorAll(
        '.js-link-collection-carousel.-carousel-images'
    );

    if (!carousels.length) {
        return;
    }

    function updateLiveRegion(splide, splideElement, liveRegion) {
        const slides = splideElement.querySelectorAll(
            '.splide__slide:not(.splide__slide--clone)'
        );
        const currentSlide = slides[splide.index];
        let alt = '';
        let caption = '';

        if (currentSlide) {
            const img = currentSlide.querySelector('img');
            if (img) alt = (img.getAttribute('alt') || '').trim();
            const captionEl = currentSlide.querySelector(
                '.carousel_images__caption'
            );
            if (captionEl) caption = captionEl.textContent.trim();
        }

        const imageParts = [alt, caption].filter(Boolean);
        const imageText =
            imageParts.length > 0
                ? imageParts.join('. ')
                : splideElement.getAttribute('data-label-no-image-text') || '';

        // this carousel always shows a single image, so the label is in singular
        const showing =
            liveRegion.getAttribute('data-label-showing-singular') +
            ' ' +
            (splide.index + 1) +
            '/' +
            splide.length;

        liveRegion.textContent = (imageText ? imageText + '. ' : '') + showing;
    }

    carousels.forEach(function (splideElement) {
        const args = {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: true,
            autoplay: false,
            role: 'group',
            i18n: H_Tools.carousel?.getLabels(splideElement),
        };

        let splide = new Splide(splideElement, args);

        H_Tools.carousel[splideElement.getAttribute('data-carousel-id')] =
            splide;

        splide.on('ready', function () {
            const liveRegion = splideElement.querySelector('.live_region');
            if (liveRegion) {
                updateLiveRegion(splide, splideElement, liveRegion);
            }

            const total = splide.length;

            // Original slides: index by DOM order
            splideElement
                .querySelectorAll('.splide__slide:not(.splide__slide--clone)')
                .forEach(function (slide, idx) {
                    const counter = slide.querySelector('.slide_counter');
                    if (counter) {
                        counter.textContent = idx + 1 + ' / ' + total;
                    }
                });

            // Clone slides: use slideIndex to match source slide's number
            splide.Components.Slides.get()
                .filter(function (s) {
                    return s.isClone;
                })
                .forEach(function (s) {
                    const counter = s.slide.querySelector('.slide_counter');
                    if (counter) {
                        counter.textContent = s.slideIndex + 1 + ' / ' + total;
                    }
                });
        });

        splide.on('moved', function () {
            const liveRegion = splideElement.querySelector('.live_region');
            if (liveRegion) {
                updateLiveRegion(splide, splideElement, liveRegion);
            }
        });

        splide.mount();
    });
})();
